module.exports = __webpack_public_path__ + "img/clipboard-list-outline.ffea7be6.svg";